function setTagalysConfiguration() {
  Tagalys.setConfiguration({
    api: { serverUrl: "https://api-r4.tagalys.com" },
    locale: "en-US",
    currency: {
      displayFormatter: "{{currencyLabel}} {{value}}",
      label: "$"
    }
  });
}

function setPlatformConfigurationForTagalys() {
  Tagalys.setPlatformConfiguration({
	  countryCode: Shopify.country, // In liquid stores, replace with Shopify.country to set the shopper's chosen country
	  baseCountryCode: "IN",
    storefrontAPI: {
      accessToken: "<APP-TOKEN>",
      myShopifyDomain: Shopify.shop,
    },
    metafields: {
      products: [
        { namespace: "custom", key: "blurb" },
        { namespace: "custom", key: "slides" },
      ],
    },
  });
}

function onTagalysReady(callback) {
  if (window.Tagalys) {
    setTagalysConfiguration();
    setPlatformConfigurationForTagalys();
    callback();
  } else {
    window.addEventListener("DOMContentLoaded", () => {
      setTagalysConfiguration();
      setPlatformConfigurationForTagalys();
      callback();
    });
  }
}